// removed by extract-text-webpack-plugin
module.exports = {"modal-backdrop":"Modal__modal-backdrop__2MTM4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Modal/Modal.css
// module id = 712
// module chunks = 1